export default __webpack_public_path__ + "static/media/LinkedIn.3bc70f01.svg";